import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "r",
  "use": "r-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"r\"><path class=\"cls-1\" d=\"M32.05 59.1v37.65h-15.4V2.52h26.62q18.24 0 27 6.83T79 30q0 17.57-18.27 25l26.62 41.75H69.82L47.26 59.1zm0-12.76h10.7q10.77 0 15.6-4t4.83-11.86q0-8-5.22-11.47t-15.72-3.48H32.05z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/r.svg
// module id = 7vCe
// module chunks = 1